import { ORG_NAME, TREATMENT_PLAN_CARD_PRINT_LOGO } from "app/appConfig";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import { formatMoney, getDateTime, getImgLogo, getImgLogoTreamentPrint, getPrintPatientCode, getSystemConfig , hideMiddleDigits } from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import React, { memo, useEffect, useState } from "react";

const FormPrintTreatmentPlanTab = ({ componentRef,pageRegisterTreatmentPlan, patient }) => {
    let rowIndex = 1 
    let rowIndexs = 1 
    return (
        <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
            <div className="form-container">
                <div className="logo-header">
                    <div className="logo">
                        {getImgLogoTreamentPrint({ height: "100px", width: "150px" })}
                    </div>
                    <div className="clinic-info">
                        <strong>  {getSystemConfig("ORG_NAME")}</strong><br />
                            Địa chỉ: {pageRegisterTreatmentPlan?.[0]?.department?.address || ""}<br />
                            Email: {pageRegisterTreatmentPlan?.[0]?.department?.email || ""}<br />
                            Phone: {pageRegisterTreatmentPlan?.[0]?.department?.phoneNumber || " "}
                    </div>
                </div>

                <h2 className="form-title">DỊCH VỤ KHÁCH HÀNG</h2>

                <h3>I. THÔNG TIN CÁ NHÂN</h3>
                <table className="info-table">
                    <tbody>
                        <tr>
                        <td className="dotted-label">
                            <span>{rowIndex++}. Tên khách hàng:</span>
                            <span className="dots">{patient?.patientInfo?.displayName || ''}</span>
                        </td>
                        <td className="dotted-label">
                            <span>Mã khách hàng:</span>
                            <span className="dots">{getPrintPatientCode(patient, patient?.patientInfo)}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label">
                            <span>{rowIndex++}. Số điện thoại:</span>
                            <span className="dots">{hideMiddleDigits(patient?.patientInfo?.phoneNumber) || ''}</span>
                        </td>
                        <td className="dotted-label">
                            <span>Nghề nghiệp:</span>
                            <span className="dots">{patient?.patientInfo?.profession?.name || ''}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label">
                            <span>{rowIndex++}. Ngày sinh:</span>
                            <span className="dots">{patient?.patientInfo?.birthDate 
                            ? new Date(patient.patientInfo.birthDate).toLocaleDateString('vi-VN') 
                            : ''}
                            </span>
                        </td>
                        <td className="dotted-label">
                            <span>Giới tính:</span>
                            <span className="dots">{patient?.patientInfo?.gender === 'F' ? 'Nữ' : 'Nam'}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label full-width" colSpan="2">
                            <span>{rowIndex++}. Nguồn:</span>
                           <span className="dots">{patient?.patientInfo?.currentPatientSource?.name || ''}</span>
                        </td>
                        </tr>

                        <tr>
                        <td className="dotted-label full-width" colSpan="2">
                            <span>{rowIndex++}. Địa chỉ:</span>
                            <span className="dots">   
                                {[
                                    patient?.patientInfo?.currentWard?.name,
                                    patient?.patientInfo?.currentDistrict?.name,
                                    patient?.patientInfo?.currentProvince?.name
                                    ]
                                .filter(Boolean)
                                .join(', ')}
                            </span>
                        </td>
                        </tr>
                    </tbody>
                </table>

                <h3>II. THÔNG TIN CHUNG</h3>
                <table className="info-table-service-product">
                    <tbody>
                        <tr>
                        <td className="label-service-product">Tổng Tiền :</td>
                        <td>
                            <span style={{fontWeight:"bold"}}>{formatMoney(pageRegisterTreatmentPlan?.[0]?.amountActuallyPaid || 0)}</span>
                        </td>
                        </tr>
                        <tr>
                            <td className="label-service-product">(Bằng chữ) :</td>
                            <td>{toVietnamese(pageRegisterTreatmentPlan?.[0]?.amountActuallyPaid || 0)}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h6 style={{ fontWeight: "bold", marginTop: "10px" }}>III. LIỆU TRÌNH</h6>
                <div className="table-responsive">
                <table className="service-table">
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Tên</th>
                        <th>SL</th>
                        <th>Đơn giá (VND)</th>
                        <th>Thành tiền (Cần thu)</th>
                        <th>TG đăng ký</th>
                    </tr>
                    </thead>
                    <tbody>
                    {pageRegisterTreatmentPlan?.map((lt, index) => {
                        let subIndex = 0; 
                        return (
                            <React.Fragment key={index}>
                            <tr style={{ fontWeight: "bold" }}>
                                <td>{index + 1}</td>
                                <td>{lt?.clientCard?.name}</td>
                                <td>{lt?.quantity}</td>
                                <td>{formatMoney(lt?.price)}</td>
                                <td>{formatMoney((lt?.price) * (lt?.quantity))}</td>
                                <td>{getDateTime(lt.startDate)}</td>
                            </tr>

                            {/* Dịch vụ */}
                            {lt?.paServiceRegister?.map((item) => {
                                subIndex++;
                                return (
                                <tr key={`service-${item.id}`}>
                                    <td></td>
                                    <td colSpan="5" style={{ paddingLeft: "20px" }}>
                                    {`${index + 1}.${subIndex}. ${item?.service?.name} (x${lt?.quantity}) | Tổng số lần điều trị: `}
                                    <span style={{ fontWeight: "bold" }}>{item?.totalPerformedTimes}</span>
                                    <span className="ml-1">/</span>
                                    <span style={{ color: "green" }}>{item?.totalTreatmentTimes ?? 0}</span>
                                    </td>
                                </tr>
                                );
                            })}

                            {/* Thuốc */}
                            {lt?.drugs?.map((item) => {
                                subIndex++;
                                return (
                                <tr key={`drug-${item.id}`}>
                                    <td></td>
                                    <td colSpan="5" style={{ paddingLeft: "20px" }}>
                                    {`${index + 1}.${subIndex}. ${item.drugName} (x${item.soldQuantity})`}
                                    </td>
                                </tr>
                                );
                            })}
                            </React.Fragment>
                        );
                    })}

                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan="4" style={{ textAlign: "center", fontWeight: "bold" }}>
                        TỔNG TIỀN:
                        </td>
                        <td style={{ fontWeight: "bold" }}>
                        {
                            formatMoney(
                            pageRegisterTreatmentPlan?.reduce(
                                (total, lt) => total + (lt?.price || 0) * (lt?.quantity || 0),
                                0
                            )
                            )
                        }
                        </td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>
                </div>
            </div>
        </PrintCommon>
    );
};

export default memo(FormPrintTreatmentPlanTab);
